// **  List of All Permission ** //

const permission = {
  itemSharing: 'item-sharing',
  messaging: 'messaging',
  userManagement: 'user-management',
  foodDelivery: 'food-delivery',
  admin: 'admin',
  appStore: 'app-store',
  admin101: '101-management',
  adminOneApp: 'one-app-management',
  writer: 'writer',
  developer: 'developer'
};

export default permission;
